import { render } from "./SolutionsModels.vue?vue&type=template&id=1c55a65c&lang=pug"
import script from "./SolutionsModels.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsModels.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsModels.vue?vue&type=style&index=0&id=1c55a65c&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__